import { IEvents } from "@walletconnect/jsonrpc-types";
export class ISubscriptionTopicMap {
    constructor() {
        this.map = new Map();
    }
}
export class ISubscription extends IEvents {
    constructor(client, logger) {
        super();
        this.client = client;
        this.logger = logger;
    }
}
//# sourceMappingURL=subscription.js.map